/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { NavigationList }   from '../../molecules/NavigationList';
import { StyledHeader }     from '../../atoms/StyledHeader';
import { NavigationBurger } from '../../../containers/NavigationBurger';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export class Header extends Component {
    constructor() {
        super();

        this.state = {
            links: [{
                id: 1,
                text: 'Home',
                to: '/',
                exact: true
            }, {
                id: 2,
                text: 'Pricing',
                to: '/pricing'
            }, {
                id: 3,
                text: 'About',
                to: '/about'
            }, {
                id: 4,
                text: 'Contact',
                to: '/contact'
            }, {
                id: 5,
                text: 'Sign In / Register',
                to: '//app.pricepaiddata.co.uk', // this should be configured per env
                target: '_blank'
            }]
        };
    }

    render() {
        return (
            <StyledHeader>
                {this.props.children}
                <NavigationBurger />
                <NavigationList items={this.state.links}/>
            </StyledHeader>
        );
    }
}

NavigationList.propTypes = {
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/organisms/Header/index.js